import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { ToastProvider } from 'react-toast-notifications';
//import SecondaryNavMenu from './SecondaryNavMenu';

export const Layout = (props) => {
    return (
        <ToastProvider autoDismissTimeout="5000" placement="bottom-left">
            <div className="d-flex flex-column h-100">
                <div className="d-flex flex-column">
                    <NavMenu {...props} />
                    <div>
                        <div className="triangle left off-white"></div>
                    </div>
                </div>
                <div className="d-flex flex-column flex-fill" style={{ overflowX: 'hidden', overflowY: 'auto' }}>
                    <Container fluid className="h-100" style={{ paddingTop: "2rem", paddingBottom: "1rem" }}>
                        {props.children}
                    </Container>
                </div>
                <div className="d-flex flex-column">
                    <div className="bg-white" style={{ zIndex: 0 }}>
                        <div className="bg-dark">
                            <Container fluid>
                                <div className="triangle right white"></div>
                            </Container>
                            <Container className="py-2" fluid>
                                <Row>
                                    <Col xs="3" lg="2" className="align-self-center">
                                        <img src={process.env.PUBLIC_URL + '/images/GREY_Logo_W_NT.PNG'} style={{ height: 30 }} alt="Greystar Logo" />
                                    </Col>
                                    <Col xs="6" lg={{ size: 4, offset: 4 }} className="align-self-center">
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </ToastProvider>
    );
};

/*                         {props.ShowSecondaryMenu ? <SecondaryNavMenu {...props} /> : null}

*/


// WEBPACK FOOTER //
// ./src/components/Shared/Layout.js